import React from 'react';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    font-size: 14px;
    font-weight: bold;
`;

const TextSubHeader = ({ children, className, style = {} }) => {
    return (
        <SLayout className={className} style={style}>
            {children}
        </SLayout>
    );
};

export default TextSubHeader;
